module.exports = __webpack_public_path__ + "static/img/c.ff5d99a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c.png
// module id = /Gu+
// module chunks = 0